"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useContext } from "react";
import { AuthContext } from "@/components/auth/Auth";
import WaveHeaderNameEdit from "./WaveHeaderNameEdit";
import { canEditWave } from "@/helpers/waves/waves.helpers";
import { getWavePathRoute } from "@/helpers/navigation.helpers";
export default function WaveHeaderName(t0) {
  const $ = _c(18);
  const {
    wave
  } = t0;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const isDirectMessage = wave.chat.scope.group?.is_direct_message ?? false;
  let t1;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile || $[2] !== isDirectMessage || $[3] !== wave) {
    t1 = !isDirectMessage && canEditWave({
      connectedProfile,
      activeProfileProxy,
      wave
    });
    $[0] = activeProfileProxy;
    $[1] = connectedProfile;
    $[2] = isDirectMessage;
    $[3] = wave;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const showEdit = t1;
  let t2;
  if ($[5] !== wave.id) {
    t2 = getWavePathRoute(wave.id);
    $[5] = wave.id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== wave.name) {
    t3 = <h1 className="tw-mb-0 tw-truncate tw-text-lg tw-font-semibold tw-tracking-tight tw-text-iron-50 tw-transition tw-duration-300 tw-ease-out desktop-hover:group-hover:tw-text-iron-400">{wave.name}</h1>;
    $[7] = wave.name;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <Link href={t2} className="tw-min-w-0 tw-no-underline">{t3}</Link>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== showEdit || $[13] !== wave) {
    t5 = showEdit && <div className="tw-mt-[7px] tw-size-4 tw-shrink-0"><WaveHeaderNameEdit wave={wave} /></div>;
    $[12] = showEdit;
    $[13] = wave;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="tw-group tw-flex tw-min-w-0 tw-items-start tw-space-x-2">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}